<template>
  <div class="tourHotelSelectRoom_topWrapper">
    <div class="tourHotelSelectRoom_hotelName">
      {{ name }}
    </div>

    <tk-star-rating
      class="tourHotelSelectRoom_rates d-flex flex-row align-items-start"
      :star-number="starNumber"
    />

    <tk-tripadvisor-rating
      v-if="tripadvisorInfo && Object.keys(tripadvisorInfo).length > 0"
      :review-count="tripadvisorInfo.reviewCount"
      :rating-image-url="tripadvisorInfo.ratingImageUrl"
      :rating-value="tripadvisorInfo.ratingValue"
      @clicked="tripadvisorClick"
    />
    <div
      v-else-if="isGoto"
      class="tripadvisor-wrapper in-list tripadvisor-searched"
    />
    <div class="tourHotelSelectRoom_desc tourHotelSelectRoom-pcOnly"></div>
  </div>
</template>

<script>
import TkStarRating from '../../atoms/TkStarRating/TkStarRating'
import TkTripadvisorRating from '../TkTripadvisorRating/TkTripadvisorRating.vue'

export default {
  name: 'TkStaticHotelPlanInfo',
  components: { TkStarRating, TkTripadvisorRating },
  props: {
    name: {
      type: String,
      required: true,
    },
    starNumber: {
      type: Number,
      default: 0,
    },
    isGoto: {
      type: Boolean,
      default: false,
    },
    tripadvisorInfo: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    tripadvisorClick() {
      this.$emit('tripadvisor-clicked')
    },
  },
}
</script>
